import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

const AddNewSite = ({
  showAddSiteModal,
  handleAddSiteModalDisplay,
  countryList,
  handleAddNewSite,
}) => (
  <>
    <Button
      size="sm"
      variant="primary"
      onClick={() => {
        handleAddSiteModalDisplay(true);
      }}
    >
      Add New Site
    </Button>

    <Modal
      show={showAddSiteModal}
      onHide={() => {
        handleAddSiteModalDisplay(false);
      }}
    >
      <Modal.Header>
        <Modal.Title className="m-0">Add New Site</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            handleAddSiteModalDisplay(false);
          }}
        />
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{
          country: '',
          siteName: '',
        }}
        validationSchema={Yup.object({
          country: Yup.string().required('Please select a country'),
          siteName: Yup.string().required('Enter site name'),
        })}
        onSubmit={(values) => {
          handleAddNewSite(values);
        }}
      >
        {(formikprops) => (
          <Form onSubmit={formikprops.handleSubmit}>
            <Modal.Body>
              <section>
                <Form.Group controlId="worksessionType">
                  <Form.Label>
                    Select Country <span className="text-danger">*</span>
                  </Form.Label>
                  <Field
                    className="form-control form-select"
                    as="select"
                    name="country"
                    placeholder="Select"
                  >
                    <option value="">Select</option>
                    {countryList.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.name} ({country.code})
                      </option>
                    ))}
                  </Field>

                  <ErrorMessage
                    name="country"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Form.Group>
                <Form.Group controlId="siteName">
                  <Form.Label>
                    Site name <span className="text-danger">*</span>
                  </Form.Label>
                  <Field
                    className="form-control"
                    type="text"
                    placeholder="Enter site name"
                    name="siteName"
                  />
                  <ErrorMessage
                    name="siteName"
                    render={(msg) => (
                      <small className="text-danger">{msg}</small>
                    )}
                  />
                </Form.Group>
              </section>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              <Button
                variant="link"
                onClick={() => {
                  handleAddSiteModalDisplay(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Add Site
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  </>
);

AddNewSite.propTypes = {
  showAddSiteModal: PropTypes.bool,
  handleAddSiteModalDisplay: PropTypes.func,
  countryList: PropTypes.array,
  handleAddNewSite: PropTypes.func,
};

export default AddNewSite;
